import { useState } from "react";
import styles from "./MeetingStatusInfo.module.css";
import TelehealthTimer from "../TelehealthTimer/TelehealthTimer";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Typography } from "@mui/material";
import { palette } from "@powerdiary/components-library/lib";

interface IProps {
    isMeetingUrlAvailable: boolean;
    startDate: string;
    isMeetingTime: boolean;
}

export default function MeetingStatusInfo({ isMeetingUrlAvailable, startDate, isMeetingTime }: Readonly<IProps>) {
    const [isTimerComplete, setIsTimerComplete] = useState(false);
    return (
        <Box>
            {!isMeetingTime && (
                <TelehealthTimer startTime={startDate} timerCompleted={() => setIsTimerComplete(true)} />
            )}

            {!isMeetingUrlAvailable && isTimerComplete && (
                <Box className={styles.container}>
                    <Typography
                        variant="paragraphMediumRegular"
                        color={palette.neutral["700"]}
                        data-test-id="text_spinner_waiting_room"
                    >
                        Please click below to join the waiting room.
                    </Typography>
                    <CircularProgress data-test-id="spinner_progress_bar" color="primary" size={16} />
                </Box>
            )}

            {isMeetingUrlAvailable && (
                <Typography
                    variant="paragraphMediumRegular"
                    color={palette.neutral["700"]}
                    data-test-id="text_click_join_waiting_room"
                >
                    Please click below to join the waiting room.
                </Typography>
            )}
        </Box>
    );
}
